import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { User, authAPI } from '../services/api';

interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  login: (mobile: string, password: string, role: 'superadmin' | 'admin' | 'manager') => Promise<{ success: boolean; error?: string }>;
  logout: () => void;
  setUser: (user: User | null) => void;
  loading: boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const currentUser = authAPI.getCurrentUser();
    const token = localStorage.getItem('token');

    // Only set user if both token and user exist
    if (currentUser && token) {
      setUser(currentUser);
    } else {
      // Clear invalid data
      if (!token) {
        localStorage.removeItem('user');
      }
      setUser(null);
    }
    setLoading(false);
  }, []);

  const login = async (mobile: string, password: string, role: 'superadmin' | 'admin' | 'manager'): Promise<{ success: boolean; error?: string }> => {
    try {
      const data = await authAPI.login(mobile, password, role);
      if (data.user) {
        setUser(data.user);
        return { success: true };
      }
      return { success: false, error: 'خطا در دریافت اطلاعات کاربر' };
    } catch (error: any) {
      console.error('Login error:', error);
      const errorMessage = error.response?.data?.error || 'شماره موبایل یا رمز عبور اشتباه است';
      return { success: false, error: errorMessage };
    }
  };

  const logout = () => {
    authAPI.logout();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, isAuthenticated: !!user, login, logout, setUser, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

